import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=63bff77e&scoped=true&"
import script from "./Notifier.vue?vue&type=script&lang=js&"
export * from "./Notifier.vue?vue&type=script&lang=js&"
import style0 from "./Notifier.vue?vue&type=style&index=0&id=63bff77e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bff77e",
  null
  
)

export default component.exports